import React from "react";

function plainClose(){
    return (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.10156 4.95099L13.1525 14.002L14.0011 13.1534L4.95009 4.10246L4.10156 4.95099Z" fill="#6B7073"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.95019 14.0021L14.0012 4.95117L13.1526 4.10264L4.10167 13.1536L4.95019 14.0021Z" fill="#6B7073"/>
        </svg>

    )
}
export default plainClose;